import type { BottleType } from "../schema";
import { INK, centred, doc, imageSlot, labelWidth, rect } from "./kit";
import type { LabelTemplate } from "./types";

// Art label: the visitor's artwork in a fixed frame above a typeset plinth.
// The frame and slot follow the label width, so each bottle has its own layout.
export const artLabel: LabelTemplate = {
  key: "art-label",
  name: "Art label",
  occasion: "modern",
  style: "Art label · frame and plinth",
  description: "Your artwork framed above a typeset plinth.",
  hasImageSlot: true,
  slot: "artwork",
  build(bottle: BottleType) {
    const W = labelWidth(bottle);
    return doc(bottle, INK["warm-white"], [
      imageSlot({ x: 6, y: 6, width: W - 12, height: 56 }, "Add your artwork"),
      rect(INK.charcoal, { x: 4, y: 4, width: W - 8, height: 60 }, 0.4),
      centred(bottle, { text: "YOUR NAME", font: "cinzel", size: 4, color: INK.charcoal, baseline: 76.5, tracking: 0.2 }),
      centred(bottle, { text: "Artist series · 2026", font: "cormorant", italic: true, size: 2.6, color: INK.charcoal, baseline: 84, tracking: 0.04 }),
    ]);
  },
};
